module.exports = __webpack_public_path__ + "img/guard-angel.cf00f9c3.svg";